import React from 'react';
import { ChefProfile, Profile } from '../interface';
import ChefProfiles from './ChefProfiles';
import PartnerProfiles from './PartnerProfiles';

type PartnersProps =
  | {
      partners: ChefProfile[];
      sectionHeader: string;
      type: 'chef';
    }
  | {
      partners: Profile[];
      type: 'partner';
    };

const Partners: React.FC<PartnersProps> = (props) => {
  const { partners, type } = props;

  if (type === 'chef') {
    const { sectionHeader } = props;
    // Pass anchorId logic to ChefProfiles
    return <ChefProfiles partners={partners} sectionHeader={sectionHeader} />;
  }

  // For partners, pass anchorId logic to PartnerProfiles
  return <PartnerProfiles partners={partners} />;
};

export default Partners;
